import { Locale } from "../enums/general"

export interface LocalizedText {
  // NOTE: Uses string literals because issues with react-hook-form,
  // might be fixed in newer versions
  "nl-NL"?: string
  "en-GB"?: string
}

export const EMPTY_LOCALIZED_TEXT: LocalizedText = { [Locale.Nl]: "", [Locale.En]: "" }

/**
 * A type guard to check if a value is a LocalizedText.
 */
export const isLocalizedText = (value: unknown): value is LocalizedText => {
  return typeof value === "object" && value !== null && "nl-NL" in value && "en-GB" in value
}
